// extracted by mini-css-extract-plugin
module.exports = {"products_eu":"EUProduct2_products_eu__8_o9A"};